import request from '@/util/request';

//新增关联设备页面————————搜索
export const getAddRelationDevice = (params, options) =>
request.get('/api/deviceinspectstandard/standardDevice', Object.assign({}, options, { params }));

//新增关联设备页面————————关联
export const settingRelationDevice = (params,options) =>
request.post('/api/deviceinspectstandard/relationDevice',  params,options);


//已关联的设备页面——————————搜索
export const getRelatedDevice = (params, options) =>
request.get('/api/deviceinspectstandard/lookStandardDevice', Object.assign({}, options, { params }));

//已关联移除关联联设备页面————————关联
export const removeRelationDevice = (params,options) =>
request.post('/api/deviceinspectstandard/removeDevice',params,options);


//新增关联设备页面————————停用搜索
export const lookStandardStopDevice = (params, options) =>
request.get('/api/deviceinspectstandard/lookStandardStopDevice', Object.assign({}, options, { params }));